import { HTTP_TOKEN } from "./http";

export const getReport = (params) => {
  return HTTP_TOKEN.get("report", { params }).then((result) => {
    return result.data;
  });
};
